import React, { useEffect, useState } from "react";
import Popup from "../../../../components/common/model/Popup";
import checkedIcon from "../../../../assets/check-mark.png";
import closeIcon from "../../../../assets/closeModel.png";
import useStyles from "../../../../components/common/model/styles";
import { DialogContent, DialogContentText, Grid } from "@mui/material";

import CustomerDetailsForm from "./store-components/CustomerDetailsForm";
import CustomButton from "../../../../components/common/button/CustomButton";
import Validation from "../../../../utils/Validation";
import { useDispatch, useSelector } from "react-redux";

import {
  getAllReferrerListAction,
  setAddNewLeadAction,
  setUpdateLeadAction,
} from "../../../../store/reducers/leadSlice";

import Notification from "../../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { setAddReferrerResponse } from "../../../../store/reducers/referrerSlice";
import { mergeDateAndTime } from "../../../../hooks/helper";

import DistanceMapModal from "../../lead/CustomerLead/DistanceMapModal";
import AlertCloseLead from "../../lead/AlertCloseLead";

import {
  addStorageAction,
  getSingleStorageAction,
  initialStorageLocalState,
  resetNewStorageLocal,
  resetStorageResponses,
  setNewStorageLocal,
  setStorageResponse,
  updateStorageAction,
} from "../../../../store/reducers/storageSlice";

import CollectionForm from "./store-components/CollectionForm";
import DeliveryForm from "./store-components/DeliveryForm";
import CustomerNotesForm from "./store-components/CustomerNotesForm";

interface ManageStorageProps {
  open: boolean;
  onHide: () => void;
  title: string;
  selectLead: any;
  action?: any;
  setSelectedLead?: any;
  screen?:string;
}

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  key: string;
}

const ManageStorage: React.FC<ManageStorageProps> = (props) => {
  const classes = useStyles();
  const { open, selectLead, title,screen } = props;
  console.log("selectLead-60", selectLead);

  const dispatch = useDispatch();

  const [isActionCalled, setIsActionCalled] = useState(false);
  const [openMap, setOpenMap] = useState(false);

  const [filterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
    key: "",
  });

  const { referrers } = useSelector((state: any) => state.lead);

  const { newStorageLocal, response } = useSelector(
    (state: any) => state.storage,
  );

  const { isAddReferrerSuccess } = useSelector((state: any) => state.referrer);

  const { userProfile } = useSelector((state: any) => state.user);

  const [isProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Lead") || false,
  );

  const [formData, setFormData]: any = useState(initialStorageLocalState);

  const [countryCode, setCountryCode] = useState<string>("+44");

  const [alternateCountryCode, setAlternateCountryCode] =
    useState<string>("+44");

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [, setOldLeadLocalState] = useState(initialStorageLocalState);

  /*
   * ---------------------------------------------------------
   * Populate storage form from selected lead
   * ---------------------------------------------------------
   */

  useEffect(() => {
    if (!selectLead) return;

    setCountryCode(
      selectLead?.customerCountryCode ||
        selectLead?.customer_country_code ||
        "+44",
    );

    setAlternateCountryCode(
      selectLead?.alternateCountryCode ||
        selectLead?.customer_alternate_country_code ||
        "+44",
    );

    /*
     * Collection Address
     */

    const rawCollectionAddress =
  selectLead?.collectionAddress ??
  selectLead?.collection_address ??
  [];

    const collectionAddress = (
      rawCollectionAddress?.length > 0
        ? rawCollectionAddress
        : [
            {
              buildingNumber: "",
              street: "",
              town: "",
              county: "",
              postcode: "",
              country: "",
              purchaseStatus: "",
              houseSize: "",
              distance: 0,
              volume: 0,
              volumeUnit: "m3",
            },
          ]
    ).map((addr: any) => ({
      buildingNumber: addr?.buildingNumber ?? addr?.building_number ?? "",

      street: addr?.street ?? "",

      town: addr?.town ?? "",

      county: addr?.county ?? "",

      postcode: addr?.postcode ?? "",

      country: addr?.country ?? "",

      purchaseStatus: addr?.purchaseStatus ?? addr?.purchase_status ?? "",

      houseSize: addr?.houseSize ?? addr?.house_size ?? "",

      distance: Number(addr?.distance) || 0,

      volume: Number(addr?.volume) || 0,

      volumeUnit: addr?.volumeUnit ?? addr?.volume_unit ?? "m3",
    }));

    /*
     * Delivery Address
     */

      const rawDeliveryAddress =
  selectLead?.deliveryAddress ??
  selectLead?.delivery_address ??
  [];

    const deliveryAddress = (
      rawDeliveryAddress?.length > 0
        ? rawDeliveryAddress
        : [
            {
              building_number: "",
              street: "",
              town: "",
              county: "",
              postcode: "",
              country: "",
              purchaseStatus: "",
              houseSize: "",
              distance: 0,
              volume: 0,
              volumeUnit: "m3",
            },
          ]
    ).map((addr: any) => ({
      buildingNumber: addr?.buildingNumber ?? addr?.building_number ?? "",

      street: addr?.street ?? "",

      town: addr?.town ?? "",

      county: addr?.county ?? "",

      postcode: addr?.postcode ?? "",

      country: addr?.country ?? "",

      purchaseStatus: addr?.purchaseStatus ?? addr?.purchase_status ?? "",

      houseSize: addr?.houseSize ?? addr?.house_size ?? "",

      distance: Number(addr?.distance) || 0,

      volume: Number(addr?.volume) || 0,

      volumeUnit: addr?.volumeUnit ?? addr?.volume_unit ?? "m3",
    }));

    /*
     * IMPORTANT:
     *
     * Do NOT spread newStorageLocal here.
     *
     * We explicitly create camelCase properties.
     */

    const updatedLead = {
      referrerId:
        selectLead?.referrerId ?? selectLead?.referrer_id ?? "",

      customer: {
        name: selectLead?.customer?.name ?? selectLead?.customer_name ?? "",

        countryCode: selectLead?.customer?.countryCode ?? "+44",

        phone: selectLead?.customer?.phone
          ? String(selectLead?.customer?.phone).replace(/^(\+91|\+44)/, "")
          : selectLead?.customer_phone ?
          selectLead?.customer_phone.replace(/^(\+91|\+44)/, "")
          : "",

        email: selectLead?.customer?.email ?? selectLead?.customer_email ?? "",

        alternatePhone: selectLead?.customer?.alternatePhone
          ? String(selectLead?.customer?.alternatePhone).replace(
              /^(\+91|\+44)/,
              "",
            )
          : selectLead?.customer_alternate_phone ?
            String(selectLead?.customer_alternate_phone).replace(
              /^(\+91|\+44)/,
              ""
            )
          : "",

        alternateCountryCode:
          selectLead?.customer?.alternateCountryCode ?? "+44",

        accountName: selectLead?.customer?.accountName ?? selectLead?.customer_account_name ?? "",

        prefix: selectLead?.customer?.prefix ?? selectLead?.customer_prefix ?? "",
      },

      collectionAddress,

      deliveryAddress,

      followUpDate:
        selectLead?.followUpDate ?? selectLead?.follow_up_date ?? "",

      followUpEndDate:
        (selectLead?.followUpDate ?? selectLead?.follow_up_date)
          ? {
              start: selectLead?.followUpDate ?? selectLead?.follow_up_date,

              end:
                selectLead?.followUpEndDate ?? selectLead?.follow_up_end_date,
            }
          : "",

      movingOnDate:
        (selectLead?.movingOnEndDate ?? selectLead?.moving_on_end_date)
          ? [
              selectLead?.movingOnDate ?? selectLead?.moving_on_date,

              selectLead?.movingOnEndDate ?? selectLead?.moving_on_end_date,
            ].filter(Boolean)
          : (selectLead?.movingOnDate ?? selectLead?.moving_on_date ?? ""),

      movingDate: selectLead?.movingDate ?? selectLead?.moving_on_date ?? "",

      movingOnEndDate:
        selectLead?.movingOnEndDate ?? selectLead?.moving_on_end_date ?? "",

      packingOnDate:
        selectLead?.packingOnDate ?? selectLead?.packing_on_date ?? "",

      moveType: selectLead?.moveType ?? selectLead?.type_of_move ?? "",

      returningDistance:
        Number(
          selectLead?.returningDistance ?? selectLead?.returning_distance,
        ) || 0,

      customerNotes:
        selectLead?.customerNotes ?? selectLead?.customer_notes ?? "",

      advertId: selectLead?.advertId ?? selectLead?.advert_id ?? "",

      promoCode: selectLead?.promoCode ?? selectLead?.promo_code ?? "",

      promoSource: selectLead?.promoSource ?? selectLead?.promo_source ?? "",

      salesPersonId:
        selectLead?.salesPersonId ?? selectLead?.sales_person_id ?? "",

      salesPersonName:
        selectLead?.salesPersonName ?? selectLead?.sales_person_name ?? "",

      leadTypeId: selectLead?.leadTypeId ?? selectLead?.lead_type_id ?? "",

      batch: selectLead?.batch ?? "",

      inceptBatch: selectLead?.inceptBatch ?? selectLead?.incept_batch ?? "",

      leadDate: selectLead?.leadDate ?? selectLead?.lead_date ?? "",
    };

    dispatch(setNewStorageLocal(updatedLead));

    // setOldLeadLocalState(updatedLead);
  }, [selectLead, dispatch]);

  /*
   * ---------------------------------------------------------
   * Validation
   * ---------------------------------------------------------
   */

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    name: newStorageLocal?.customer?.name || "",
    referrerId: newStorageLocal?.referrerId || "",
    email: newStorageLocal?.customer?.email || "",
    phone: newStorageLocal?.customer?.phone || "",
  });

  /*
   * ---------------------------------------------------------
   * Reset
   * ---------------------------------------------------------
   */

  const resetStorageForm = () => {
    dispatch(resetNewStorageLocal());

    dispatch(resetStorageResponses());

    dispatch(
      setNotificationAction({
        message: [],
        severity: "error",
      }),
    );

    resetAllValidator();

    setCountryCode("+44");

    setAlternateCountryCode("+44");

    setHasUnsavedChanges(false);

    setIsActionCalled(false);
  };

  /*
   * ---------------------------------------------------------
   * Hide popup
   * ---------------------------------------------------------
   */

  const hideHandler = () => {
    if (hasUnsavedChanges) {
      setAlertModelShow(true);
    } else {
      props.onHide();

      resetStorageForm();

      dispatch(setNewStorageLocal(false));

      dispatch(
        setNotificationAction({
          message: [],
          severity: "error",
        }),
      );

      resetAllValidator();

      setFormData(initialStorageLocalState);
    }
  };

  /*
   * ---------------------------------------------------------
   * Referrer list
   * ---------------------------------------------------------
   */

  useEffect(() => {
    dispatch(
      setNotificationAction({
        message: [],
        severity: "error",
      }),
    );

    dispatch(getAllReferrerListAction(filterOption));
  }, [dispatch, filterOption]);

  useEffect(() => {
    if (isAddReferrerSuccess) {
      dispatch(getAllReferrerListAction(filterOption));

      dispatch(setAddReferrerResponse(false));
    }
  }, [isAddReferrerSuccess, dispatch, filterOption]);

  /*
   * ---------------------------------------------------------
   * Submit
   * ---------------------------------------------------------
   */

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    checkValidator();

    setIsActionCalled(true);
  };

  useEffect(() => {
    if (!isActionCalled) return;

    const { start, end } = newStorageLocal?.followUpEndDate || {};

    const followUpDate =
      mergeDateAndTime(newStorageLocal?.followUpDate, start) ||
      newStorageLocal?.followUpDate ||
      "";

    const followUpEndDate =
      mergeDateAndTime(newStorageLocal?.followUpDate, end) || "";

    /*
     * Collection Address
     */
    const collectionAddress = (newStorageLocal?.collectionAddress || []).map(
      (item: any) => ({
        buildingNumber: item?.buildingNumber ?? item?.building_number ?? "",

        street: item?.street ?? "",

        town: item?.town ?? "",

        county: item?.county ?? "",

        postcode: item?.postcode ?? "",

        country: item?.country ?? "",

        purchaseStatus: item?.purchaseStatus ?? item?.purchase_status ?? "",

        houseSize: item?.houseSize ?? item?.house_size ?? "",

        distance: Number(item?.distance) || 0,

        volume: Number(item?.volume) || 0,

        volumeUnit: item?.volumeUnit ?? item?.volume_unit ?? "m3",
      }),
    );

    /*
     * Delivery Address
     */
    const deliveryAddress = (newStorageLocal?.deliveryAddress || []).map(
      (item: any) => ({
        buildingNumber: item?.buildingNumber ?? item?.building_number ?? "",

        street: item?.street ?? "",

        town: item?.town ?? "",

        county: item?.county ?? "",

        postcode: item?.postcode ?? "",

        country: item?.country ?? "",

        purchaseStatus: item?.purchaseStatus ?? item?.purchase_status ?? "",

        houseSize: item?.houseSize ?? item?.house_size ?? "",

        distance: Number(item?.distance) || 0,

        volume: Number(item?.volume) || 0,

        volumeUnit: item?.volumeUnit ?? item?.volume_unit ?? "m3",
      }),
    );

    /*
     * -------------------------------------------------------
     * FINAL PAYLOAD
     *
     * ONLY camelCase keys are defined here.
     * -------------------------------------------------------
     */

    const processedLeadValue = {
      referrerId: newStorageLocal?.referrerId || "",

      clientReferrerId: newStorageLocal?.clientReferrerId || "",
      removalLeadId:selectLead?.generated_id || "",
      customer: {
        name: newStorageLocal?.customer?.name || "",

        countryCode: countryCode || "",

        phone: newStorageLocal?.customer?.phone
          ? String(newStorageLocal?.customer?.phone)
          : "",

        email: newStorageLocal?.customer?.email || "",

        alternatePhone:
          newStorageLocal?.customer?.alternatePhone ??
          newStorageLocal?.customer?.alternate_phone ??
          "",

        alternateCountryCode: alternateCountryCode || "",

        accountName:
          newStorageLocal?.customer?.accountName ??
          newStorageLocal?.customer?.account_name ??
          "",

        prefix: newStorageLocal?.customer?.prefix || "",
      },

      collectionAddress,

      deliveryAddress,

      followUpDate,

      followUpEndDate,

      movingOnDate: Array.isArray(newStorageLocal?.movingOnDate)
        ? newStorageLocal.movingOnDate[0]
        : newStorageLocal?.movingOnDate || "",

      movingOnEndDate: Array.isArray(newStorageLocal?.movingOnDate)
        ? newStorageLocal.movingOnDate[1]
        : newStorageLocal?.movingOnEndDate || "",

      movingDate: newStorageLocal?.movingDate || "",

      packingOnDate: newStorageLocal?.packingOnDate || "",

      moveType: newStorageLocal?.moveType || "",

      returningDistance: Number(newStorageLocal?.returningDistance) || 0,

      customerNotes: newStorageLocal?.customerNotes || "",

      advertId: newStorageLocal?.advertId || "",

      promoCode: newStorageLocal?.promoCode || "",

      promoSource: newStorageLocal?.promoSource || "",

      salesPersonId: newStorageLocal?.salesPersonId || "",

      salesPersonName: newStorageLocal?.salesPersonName || "",

      leadTypeId: newStorageLocal?.leadTypeId || "",

      batch: newStorageLocal?.batch || "",

      inceptBatch: newStorageLocal?.inceptBatch || "",

      leadDate: newStorageLocal?.leadDate || "",
    };

    /*
     * -------------------------------------------------------
     * Referrer logic
     * -------------------------------------------------------
     */

    if (newStorageLocal?.referrerId) {
      const matchedReferrer = referrers.find(
        (ref: any) => ref.id === newStorageLocal.referrerId,
      );

      if (matchedReferrer && matchedReferrer.from === "client") {
        processedLeadValue.clientReferrerId = newStorageLocal.referrerId;

        processedLeadValue.referrerId = "";
      }
    }

    console.log("FINAL processedLeadValue:", processedLeadValue);

    /*
     * -------------------------------------------------------
     * API CALL
     * -------------------------------------------------------
     */

    if (!isError() && error !== null && isActionCalled) {
      if (selectLead?.leadId) {
        dispatch(
          updateStorageAction({
            ...processedLeadValue,
            id: selectLead.leadId,
          }),
        );
      } else {
        dispatch(addStorageAction(processedLeadValue));
      }

      setHasUnsavedChanges(false);
    }

    setIsActionCalled(false);
  }, [
    isActionCalled,
    newStorageLocal,
    countryCode,
    alternateCountryCode,
    referrers,
    selectLead,
    dispatch,
    error,
    isError,
  ]);

  /*
   * ---------------------------------------------------------
   * Close
   * ---------------------------------------------------------
   */

  const closeModel = () => {
    hideHandler();
  };

  /*
   * ---------------------------------------------------------
   * API success
   * ---------------------------------------------------------
   */

  useEffect(() => {
    if (response?.addStorage || response?.updateStorage) {
      const currentLeadId = selectLead?.leadId ?? selectLead?.generated_id ?? selectLead;

      if (currentLeadId && screen === "storage") {
        dispatch(getSingleStorageAction({ storageId: currentLeadId }));
      }

      hideHandler();

      dispatch(setUpdateLeadAction(false));

      dispatch(setAddNewLeadAction(false));

      dispatch(setStorageResponse(false));
    }
  }, [response?.addStorage, response?.updateStorage, dispatch, selectLead]);

  const [aleryModelShow, setAlertModelShow] = useState(false);

  /*
   * ---------------------------------------------------------
   * Alert close
   * ---------------------------------------------------------
   */

  const handleClose = () => {
    setAlertModelShow(false);

    props.onHide();

    dispatch(resetNewStorageLocal());

    dispatch(setNewStorageLocal(false));

    dispatch(
      setNotificationAction({
        message: [],
        severity: "error",
      }),
    );

    resetAllValidator();

    setFormData(initialStorageLocalState);
  };

  /*
   * ---------------------------------------------------------
   * UI
   * ---------------------------------------------------------
   */

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"lg"}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              style={{ right: 40 }}
              alt="save"
            />

            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={<></>}
      >
        <DialogContent
          sx={{
            padding: "16px 10px !important",
          }}
        >
          <DialogContentText>
            <>
              <Notification />

              <Grid container spacing={0}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    display: "ruby",
                    paddingLeft: "0px !important",
                  }}
                >
                  <CustomerDetailsForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                    selectLead={selectLead}
                    setCountryCode={setCountryCode}
                    countryCode={countryCode}
                    setAlternateCountryCode={setAlternateCountryCode}
                    alternateCountryCode={alternateCountryCode}
                  />

                  <CollectionForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                  />

                  <DeliveryForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                  />

                  <CustomerNotesForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                  />

                  {isProfessionalSection && (
                    <CustomButton
                      title="Distance Map view"
                      onClick={() => setOpenMap(true)}
                      style={{
                        marginTop: 10,
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>

      {aleryModelShow && (
        <AlertCloseLead
          open={aleryModelShow}
          title="Alert"
          setAlertModelShow={setAlertModelShow}
          onHide={handleClose}
        />
      )}

      {openMap && (
        <DistanceMapModal
          open={openMap}
          onHide={() => setOpenMap(false)}
          collections={newStorageLocal?.collectionAddress || []}
          deliveries={newStorageLocal?.deliveryAddress || []}
        />
      )}
    </>
  );
};

export default ManageStorage;
